import * as core from '../../../../../../../core'

import { query } from './change-impact-details.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impact.details',
    description: 'Details view for a change impact',
    name: 'Change Impact Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
